/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { GeoLocationRecordType } from "~/features/dashboard/types";
import { Geo } from "~/features/statistics/types";

const transformToGeoLocation = (apiData: Geo["data"]): Record<string, GeoLocationRecordType> => {
  const transformed: Record<string, GeoLocationRecordType> = {};

  apiData.items.forEach((country) => {
    transformed[country.country] = {
      countryCode: country.country,
      netRevenue: Number(country.netRevenue),
    };
  });

  return transformed;
};

export default transformToGeoLocation;
